import { useRef, useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { LinkContainer } from 'react-router-bootstrap'
import "./topup.scss";

import * as secureActions from "../../store/secure/actions";
import { useSelector, useDispatch } from "react-redux";
import { getAccessToken } from "../../store/auth/selector";
import { getPaymentRateData, getPaymentRateLoadding } from "../../store/secure/selector";
import { useTranslation } from "react-i18next";
import { getAppInfo, getGateConf } from "../../store/app/selector";
const Topup = () => {

    const appInfo = useSelector(state => getAppInfo(state))
    const access_token = useSelector(state => getAccessToken(state, appInfo))
    const paymentRateData = useSelector(state => getPaymentRateData(state))
    const isRateLoadding = useSelector(state => getPaymentRateLoadding(state))
    const gateConf = useSelector(state => getGateConf(state))

    const dispath = useDispatch();

    const paymethod = useRef(null);

    const [methods, setMethods] = useState(undefined);
    const [channels] = useState("LP_GCash_Direct")

    useEffect(() => {
        if(gateConf.ci){
            dispath(secureActions.getPaymentRate(access_token, channels, appInfo, gateConf.apiUrl))
        }
        
    }, [appInfo])

    useEffect(() => {
        
    }, [isRateLoadding])


    const onPriceClick = (e, item) => {

        const data = paymentRateData.lists[item];

        setMethods(data);

        setTimeout(() => {
            paymethod.current.scrollIntoView({ behavior: 'smooth' });
        }, 10)

    }

    const {t} = useTranslation('translations');

    return (
        <>
            <div id="topup">
                <div className="listprices">

                    <div className="row prices">
                        {
                            paymentRateData !== undefined &&
                            Object.keys(paymentRateData.lists)
                                .map(key => {
                                    const arr = paymentRateData.lists[key];
                                    const max = arr.reduce((a, cur) => (a.bonus > cur.bonus ? a : cur));
                                    return { key, max };
                                })
                                .filter(({ max }) => Number(max.cashDisplay) !== 10)
                                .map(({ key, max }) => (
                                    <div className="row item" key={max + key}>
                                        <div className="col-5 chips align-self-center">
                                            <span className="value">{max.chipDisplay}</span>
                                            <span className="rate">{max.rateDisplay}</span>
                                        </div>
                                        <div className="col-2 bonus align-self-center">{max.bonus}%</div>
                                        <div className="col-5 price align-self-end text-right">
                                            <Button onClick={(e) => onPriceClick(e, key)} type="button">{max.cashDisplay}</Button>
                                        </div>
                                    </div>
                                ))
                        }

                    </div>
                </div>
                <div className="paymethod" ref={paymethod}>
                    {methods &&
                        <>
                            <div className="bg title rounded">+{t('txt8')}:</div>
                            <div className="methods">
                                {
                                    methods.map((item, index) => {
                                        return (
                                            <div key={item + index} className="bg item rounded row">
                                                <div className="details col-9"><span className="channel">{item.channel}</span><span className="info">{item.cashDisplay} (Bonus {item.bonus}%) {'>>>'} {item.chipDisplay}</span></div>
                                                <LinkContainer to={'/pay/gcash/' + item.price}>
                                                    <a className="button col-3">Buy Chip</a>
                                                </LinkContainer>
                                            </div>
                                        )
                                    })
                                }

                            </div>
                        </>
                    }
                </div>

            </div>
        </>
    );
}

export default Topup;